<div class="app-container">
  @if (isAppLoading$ | async) {
    <app-loader />
  }
  <router-outlet />
</div>
